import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
const PurchaseRegisterComponent = loadable(
  () => import("../../components/CBMSReports/PurchaseRegister")
);

const PurchaseRegister = () => {
  return (
    <>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Purchase Register
        </h1>
      </div>
      <PurchaseRegisterComponent />
    </>
  );
};

export default PurchaseRegister;
